import type { AffiliateBadgeType } from '@/modules/pmt/interfaces';
import styled from 'styled-components';

const badgeColors: Record<AffiliateBadgeType, { backgroundColor: string; color: string }> = {
  'amazons-choice': {
    backgroundColor: '#E7F0F7',
    color: '#146EB4',
  },
  prime: {
    backgroundColor: '#E5F6FC',
    color: '#00A8E1',
  },
  coupon: {
    backgroundColor: '#EDF6EF',
    color: '#1B7837',
  },
  'limited-time-deal': {
    backgroundColor: '#FAE7EB',
    color: '#CC0B39',
  },
};

export const Container = styled.div<{ type: AffiliateBadgeType }>(({ theme, type }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: `${theme.spacing[2]} ${theme.spacing[8]}`,
  height: '20px',
  width: 'fit-content',
  borderRadius: theme.spacing[4],
  backgroundColor: badgeColors[type].backgroundColor,
  color: badgeColors[type].color,
}));
